module.exports = __webpack_public_path__ + "img/undraw_sentiment_analysis_jp6w.ce712694.svg";